import axios from "axios";
import home from "../../home/home";
import {calculateTimeDifferenceTwoDates, geDataFormat, logOut} from "../../../common/utils";
import jwt_decode from "jwt-decode";
import mookAree from "./moookImpostazioni.json"
export default class DashboardImpostazioniService{

    // getDataTableArea(onSuccess){
    //   onSuccess(mookAree)
    // }


    getDataTableSettings(onSuccess) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.get(host+"/api/v1/impostazioni/find/imp", configHeaders).then(function(result){
        if(result.status === 401){
          logOut();
        }
          onSuccess(result.data);
      }, function(error){
       if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onSuccess("");
      });
    }

    SalvaGesTioneValori(oggettoValore,onSuccess) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.post(host+"/api/v1/impostazioni/save/imp", oggettoValore , configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
          onSuccess(result);
      }, function(error){
         if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onSuccess("");
      });
    }

    getSwaggerStatus(onSuccess) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.get(host+"/api/v1/impostazioni/swagger", configHeaders).then(function(result){
        if(result.status === 401){
          logOut();
        }
          onSuccess(result.data);
      }, function(error){
       if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onSuccess("");
      });
    }

    changeSwaggerStatus(onSuccess) {
      var objUser = JSON.parse(sessionStorage.getItem("user"));
      var decoded = jwt_decode(objUser.token);
      let host = process.env.REACT_APP_API_URL;
      const configHeaders = {
        headers: {
          Authorization: "Bearer " + objUser.token,
          CF: decoded.CFA,
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        }
      };
     axios.patch(host+"/api/v1/impostazioni/swagger", {}, configHeaders).then(function(result){
      if(result.status === 401){
        logOut();
      }
        onSuccess(result);
      }, function(error){
         if(error.response.status === 401){
          logOut();
        }
          console.log("Errore di  "+error);
          onSuccess("");
      });
    }

}
